import { ContainerClient } from '@azure/storage-blob';
export const getBlobItemCount = async (containerUrl, path) => {
  let count = 0;
  const containerClient = new ContainerClient(containerUrl);
  const iter = containerClient.listBlobsByHierarchy('/', {
    prefix: "".concat(path, "/")
  });
  let entity = await iter.next();
  while (!entity.done) {
    count++;
    entity = await iter.next();
  }
  return count;
};